import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import FrontText from "../FrontText";
import { Link } from "@inertiajs/react";
import { Icon } from "@iconify/react";

import NEWEST_POSTS_FRAGMENT from "@/Query/Fragments/NEWEST_POSTS_FRAGMENT";
import Skeleton from "@/Components/Preloaders/Skeleton";
import GraphImage from "../GraphImage/GraphImage";
import { useTranslation } from 'react-i18next';
import FrontSquareBeforeText from "../Partials/FrontSquareBeforeText";

// import * as ApolloPkg from '@apollo/client';
// import { gql } from '@apollo/client/core/core.cjs';
// import { useQuery } from "@apollo/client/react/hooks/hooks.cjs";
// import { useQuery, gql } from "@apollo/client/apollo-client.min.cjs";
// import { useQuery, gql } from "@apollo/client";
import gql from 'graphql-tag';
import { useQuery } from "@apollo/client/react/hooks/hooks.cjs";

const FrontLatestPostsMixed = ({
    heading,
}) => {
    // const { useQuery, gql } = ApolloPkg;
    const { t, i18n } = useTranslation();

    if (!heading) {
        heading = t('news_page.section_title_mixed_posts');
    }

    const currentLanguage = i18n.resolvedLanguage.toUpperCase();

    const LATEST_POSTS = gql`
        query GetPosts($lang: LanguageCodeFilterEnum!, $secondLang: LanguageCodeEnum!) {
            posts(first: 3, where: {status: PUBLISH, language: $lang }) {
                edges {
                    node {
                        ${NEWEST_POSTS_FRAGMENT}
                        translation(language: $secondLang) {
                            slug
                        }
                        categories {
                            nodes {
                                slug
                            }
                        }
                    }
                }
            }
        }
    `;

    const { loading, error, data } = useQuery(LATEST_POSTS, {
        variables: { lang: currentLanguage, secondLang: currentLanguage === 'PL' ? 'EN' : 'PL' },
        ssr: true,
    });
    
    return (
        <Container>
            <Row>
                <Column className="mb-8">
                    <div className="flex justify-between items-center">
                        <FrontSquareBeforeText>
                            {heading}
                        </FrontSquareBeforeText>
                    </div>
                </Column>
                <Column>
                    <Row className='gap-y-10'>
                        { error &&
                            <Column>
                                <Skeleton />
                            </Column>
                        }
                        {loading ?
                            <>
                                {Array.from({ length: 3 }, (_, index) => (
                                    <Column key={index} xl={4} lg={4} md={4}>
                                        <Skeleton />
                                    </Column>
                                ))}
                            </>
                            :
                            data && data.posts.edges.map((elem) => {
                                const { id, slug, title, featuredImage, date } = elem.node
                                const { sizes } = featuredImage.node.mediaDetails
                                const { mediaItemUrl } = featuredImage.node
                                const tax = elem.node.categories.nodes[0].slug
                                const secondLangSlug = elem.node.translation?.slug
                                
                                return(
                                    <Column xl={4} lg={4} md={4} key={id}>
                                        <Link
                                            href={route(currentLanguage === 'PL' ? 'front.news.single' : 'front.news.single.en', {taxonomy: tax, slug: slug})}
                                            title={title}
                                            className="hover:[&_.article-inner]:bg-dark-blue-standard hover:[&>article]:drop-shadow-article-box [&:hover_.content]:text-white h-full"
                                        >
                                            <article className="rounded-10 overflow-hidden h-full border border-ECECEC drop-shadow-none transition-all ease-in-out duration-300">
                                                <div className="article-inner bg-white flex flex-col h-full transition-all ease-in-out duration-300">
                                                    <div>
                                                        <GraphImage sizes={sizes} original={mediaItemUrl} className="w-full object-cover" alt={title}/>
                                                    </div>
        
                                                    <div className="py-5 px-7 flex flex-col gap-5 h-full">
                                                        <FrontText
                                                            textSize="14/16"
                                                            className="content font-bold font-domine text-standard-black transition-all ease-in-out duration-300 uppercase"
                                                        >
                                                            <p>
                                                                {title}
                                                            </p>
                                                        </FrontText>
        
                                                        <div className="flex items-center justify-between text-30548A mt-auto">
                                                            <FrontText
                                                                textSize="14/16"
                                                                className="font-bold font-domine"
                                                            >
                                                                <span>
                                                                    {new Date(date).toLocaleDateString(currentLanguage, { day: 'numeric', month: 'long', year: 'numeric' })}
                                                                </span>
                                                            </FrontText>
        
                                                            <Icon
                                                                icon="material-symbols:menu-book-rounded"
                                                                width={27}
                                                                height={24}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </article>
                                        </Link>
                                    </Column>
                                )
                            })
                        }

                    </Row>
                </Column>
            </Row>
        </Container>
    );
};

export default FrontLatestPostsMixed;
